import { useAdminOpsSnapshot } from '../../use-admin-ops-snapshot';
import { PendingBreakRequestsAlertStrip } from './PendingBreakRequestsAlertStrip';

interface Props {
  readonly accessToken: string;
}

/**
 * Admin-only pending-break-requests widget mounted inline on the consolidated
 * Activity view (sibling of `<AdminStuckJobsSection>`). Subscribes to
 * `useAdminOpsSnapshot` — the same query key the stuck-jobs section uses, so
 * React Query serves both from one cache and one 5s polling tick.
 *
 * Renders nothing until the snapshot has loaded, and the underlying strip
 * hides itself entirely when the list is empty — the absence of the strip
 * IS the all-clear signal.
 */
export function AdminPendingBreakRequestsSection({ accessToken }: Props) {
  const snapshotQuery = useAdminOpsSnapshot(accessToken);
  if (!snapshotQuery.data) return null;
  return (
    <PendingBreakRequestsAlertStrip
      accessToken={accessToken}
      pendingBreakRequests={snapshotQuery.data.pendingBreakRequests}
    />
  );
}
